
import PropTypes from 'prop-types';

const CampaignDescription = ({ description }) => {
  return (
    <div className="mt-6 sm:mt-8">
      <p className="text-gray-700 text-sm sm:text-base whitespace-pre-line text-left">
        {description}
      </p>
    </div>
  );
};

CampaignDescription.propTypes = {
  description: PropTypes.string,
};

export default CampaignDescription;